  import { useModulesStore } from '@/stores/useModulesStore'
import Hstack from '@/components/ui/hstack'
import Input from '../input2'

interface Props {
  name: string
  onNameChange: (value: string) => void
  readOnly?: boolean
  moduleId?: number
}

export default function BasicInfoForm({
  name,
  onNameChange,
  // readOnly,
  moduleId,
}: Props) {
  const { items } = useModulesStore()
  const module = items.find((item) => item.id === moduleId)
  return (
    <Hstack gap={'16px'}>
      <Input
        title='Name'
        placeholder='Name'
        textInputColor='#002652'
        value={name || ''}
        onChange={(e) => onNameChange(e.target.value)}
        disabled={false}
      />
      <Input
        title='Module'
        placeholder='Class Name'
        textInputColor='#002652'
        disabled
        value={module?.name || ''}
      />
    </Hstack>
  )
}
